var map = {
	"./1.svg": 32,
	"./11.svg": 33,
	"./12.svg": 34,
	"./13.svg": 35,
	"./14.svg": 36,
	"./15.svg": 37,
	"./16.svg": 38,
	"./17.svg": 39,
	"./18.svg": 40,
	"./19.svg": 41,
	"./2.svg": 42,
	"./20.svg": 43,
	"./21.svg": 44,
	"./22.svg": 45,
	"./23.svg": 46,
	"./24.svg": 47,
	"./25.svg": 48,
	"./26.svg": 49,
	"./27.svg": 50,
	"./3.svg": 51,
	"./30.svg": 52,
	"./31.svg": 53,
	"./32.svg": 54,
	"./33.svg": 55,
	"./34.svg": 56,
	"./35.svg": 57,
	"./36.svg": 58,
	"./37.svg": 59,
	"./38.svg": 60,
	"./39.svg": 61,
	"./4.svg": 62,
	"./40.svg": 63,
	"./41.svg": 64,
	"./42.svg": 65,
	"./43.svg": 66,
	"./44.svg": 67,
	"./5.svg": 68,
	"./6.svg": 69,
	"./7.svg": 70,
	"./8.svg": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;